import styled from "@emotion/styled";
import { themeColorPicker } from "../../../utils/themeSelectors";

export const StyledHeader = styled.div`
  background: ${themeColorPicker('white01')};
  padding: 0.5rem 1rem;
`;